/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmKonfiguracniSkupina extends GContentBase<SeznamAdmKonfiguracniSkupinaObj> {
        private seznamObj: SeznamAdmKonfiguracniSkupinaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmKonfiguracniSkupinaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmKonfiguracniSkupinaNew",
                contentCaption: "jres:33000367", //RC 33000367 : Konfigura�n� skupiny
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{nazev}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,poznamka,ico,dat_zmena,zmenu_provedl,ktg_usr_txt,ixs_usr"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmKonfiguracniSkupinaObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmKonfiguracniSkupina", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmKonfiguracniSkupina",
                newRecord: isNew,
                ixs_usr: isNew == true ? null : data.ixs_usr
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamProgramovaInstance: {
                    icon: "fa-link",
                    caption: "jres:29802871",
                    run: (ev, ctx) => {
                        var activeRow = this.grid.ggrid("activeRow");
                        if (activeRow)
                            Gordic.Adm.WebControls.AdmKonfiguracniSkupina.openSeznamAdmKonfiguracniSkupinaProgramovaInstance(activeRow);
                    }
                },
                actOpenSeznamFunkcnichMist: {
                    icon: "fa-link",
                    caption: "jres:29802922",
                    run: (ev, ctx) => {
                        var activeRow = this.grid.ggrid("activeRow");
                        if (activeRow)
                            Gordic.Adm.WebControls.AdmKonfiguracniSkupina.openSeznamAdmFunkcniMistoKonfiguracniSkupina(activeRow);
                    }
                },
                actOpenHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance: {
                    icon: "fa-link",
                    caption: "jres:33000611",
                    run: () => {
                        this.openHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actOpenSeznamProgramovaInstance },
                    { action: this.cnt.actions.actOpenHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance },
                    { action: this.cnt.actions.actOpenSeznamFunkcnichMist }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenSeznamProgramovaInstance*", "actOpenHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance*","actOpenSeznamFunkcnichMist*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmKonfiguracniSkupina.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSeznamProgramovaInstance?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actOpenSeznamFunkcnichMist?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_usr),
                nazev: ""
            }
        }


        private openHromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        ixs_usr: item["ixs_usr"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance"], { ID: "HromadnaOperaceAdmKonfiguracniSkupinaProgramovaInstance", data: data, typ_usr: 0 }, "", 1000, 600)
        }
    }
}